@use "~theme/breakpoints";

.content {
  display: flex;
  justify-content: center;
  flex: 1;
}

.contentV2 {
  display: block;
  margin-top: 10px;
}

.layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
}

.navbarWrapper {
  display: block;
  position: relative;
  z-index: 1;
}

.navbarWithBanner {
  margin-top: 0;
}

.navbarWithBanner :global(.bar) {
  border-bottom: none;
}

.bannerStack {
  position: relative;
  z-index: 2;
}

.LayoutFull {
  display: block;
  width: 100%;
  .content {
    display: block;
  }
}

.layoutV2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  background-color: white !important;
}

.emptyHeight {
  height: 68px;
  min-height: 68px;
}

.summaryHeight {
  height: 68px;
  min-height: 68px;
  @include breakpoints.desktop {    
    height: 0px;
    min-height: 0px;
  }
}
.emptyHeight2 {
  height: 120px;
  min-height: 120px;
  @include breakpoints.desktop {
    height: 68px;
    min-height: 68px;
  }
}

.sadLayoutHeight {
  height: 120px;
  min-height: 120px;
  @include breakpoints.desktop {
    height: 0px;
    min-height: 0px;
  }
}